import React, { useEffect } from 'react';
import { LocaleProvider } from 'antd2';
import enUS from 'antd2/es/locale-provider/en_US';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WsThemeProvider } from '@helloworld1812/app-global-components';
import { useNavigate } from 'react-router-dom-v5-compat';
import { setNavigateFn } from '@helloworld1812/ws-router';
import { WsI18nProvider } from '@helloworld1812/ws-i18n';

import { i18nInstance, set3rdPartyLanguage, Language } from './i18n';

const queryClient = new QueryClient();

export function NonBusinessApp({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigateFn((path: string) => {
      if (/^https?:\/\//.test(path)) {
        window.location.href = path;
      } else if (path.startsWith('/#/')) {
        navigate(path.replace(/^\/#/, ''));
      } else {
        navigate(path);
      }
    });
  }, [navigate]);

  useEffect(() => {
    set3rdPartyLanguage((i18nInstance.resolvedLanguage as Language) ?? 'en');

    i18nInstance.on('languageChanged', (lng) => {
      set3rdPartyLanguage(lng as Language);

      queryClient.invalidateQueries();
    });
  }, []);

  return (
    <WsI18nProvider i18n={i18nInstance} defaultNS="hr-app">
      <WsThemeProvider>
        <LocaleProvider locale={enUS}>
          <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </LocaleProvider>
      </WsThemeProvider>
    </WsI18nProvider>
  );
}
